import __pages_import_0__ from "/src/pages/index.vue";

const routes = [{"name":"index","path":"/","component":__pages_import_0__,"props":true}];

export default routes;